/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 13:02:38
 * @LastEditTime: 2022-06-13 17:38:58
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/Components/DeliveryMethod.tsx
 */

import EditDraggableTable from '@/src/components/DroppableTable/EditDraggableTable';
import {
  EditIcon,
  FrontTitle,
} from '@/src/components/EditableTable/EditableTable';
import { getCourierShow } from '@/src/pages/Settings/Logistics/CourierAccount/tools';
import { Form } from 'antd';
import React, { useMemo } from 'react';
import { SizeFittingTable } from 'src/components/Antd';
import { TableInput } from 'src/components/EditableTable/TableForm/TableForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from '../style.module.less';
const DeliveryMethod = ({
  value: deliveryMethods,
  onChange,
  isPrimary,
  disableEdit,
}: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const list = useMemo(() => {
    const sortList = (deliveryMethods || []).map((item) => {
      if (disableEdit) {
        return {
          ...item,
          dragable: false,
          hideDragHandler: true,
          disabled: true,
        };
      }
      const checked = item.checked;
      //   const disabled = !item.enabled;
      return {
        ...item,
        dragable: checked,
        checked: checked,
        hideDragHandler: !checked,
        // disabled: disabled,
      };
    });

    // 已勾选,可选择
    const checkedList = sortList.filter((i) => i.checked && !i.disabled);
    // 未勾选, 可选择
    const unCheckedList = sortList.filter((i) => !i.checked && !i.disabled);
    // 已勾选, 不可选择
    const disabledCheckedList = sortList.filter((i) => i.checked && i.disabled);
    // 未勾选, 不可选择
    const disabledList = sortList.filter((i) => !i.checked && i.disabled);
    return checkedList.concat(unCheckedList, disabledCheckedList, disabledList);
  }, [deliveryMethods]);

  const columns = [
    {
      title: getI18n('general.deliveryMethod'),
      dataIndex: ['storeDeliveryMethod', 'name'],
      key: 'name',
      minWidth: 192,
      default: true,
    },
    {
      title: getI18n('salesChannelLogistics.index.shippingZone'),
      dataIndex: ['storeDeliveryMethod', 'shippingZone', 'name'],
      key: 'shippingZone',
      minWidth: 160,
      default: true,
    },
    {
      title: getI18n('salesChannelLogistics.index.logisticCourier'),
      dataIndex: ['storeDeliveryMethod', 'courierAccount'],
      key: 'courierAccount',
      minWidth: 160,
      default: true,
      childGenerate: (text) => {
        return text ? getCourierShow(text) : '';
      },
    },
    {
      title: getI18n('salesChannelLogistics.index.deliverySpeed'),
      dataIndex: ['storeDeliveryMethod', 'shippingSpeed'],
      key: 'shippingSpeed',
      minWidth: 192,
      default: true,
    },
    {
      title: (
        <FrontTitle>
          <EditIcon />
          <span>
            {getI18n('salesChannelLogistics.index.deliveryMethodTitle')}
          </span>
        </FrontTitle>
      ),
      minWidth: 320,
      dataIndex: ['storeDeliveryMethod', 'uuid'],
      key: 'title',
      default: true,
      render: (text, record, index) => {
        const _index = deliveryMethods.findIndex(
          (item) =>
            item.storeDeliveryMethod.uuid === record.storeDeliveryMethod.uuid,
        );

        return (
          <Form.Item name={['deliveryMethods', _index, 'title']}>
            <TableInput disabled={disableEdit} />
          </Form.Item>
        );
      },
    },
    {
      title: (
        <FrontTitle>
          <EditIcon />
          <span>
            {getI18n('salesChannelLogistics.index.logisticMethodRemarks')}
          </span>
        </FrontTitle>
      ),
      minWidth: 320,
      dataIndex: ['storeDeliveryMethod', 'uuid'],
      key: 'remarks',
      default: true,
      render: (text, record, index) => {
        const _index = deliveryMethods.findIndex(
          (item) =>
            item.storeDeliveryMethod.uuid === record.storeDeliveryMethod.uuid,
        );

        return (
          <Form.Item name={['deliveryMethods', _index, 'remarks']}>
            <TableInput disabled={disableEdit} />
          </Form.Item>
        );
      },
    },
  ];

  const onSelectChange = (selectedList) => {
    onChange(
      list.map((item) => {
        return {
          storeDeliveryMethod: item.storeDeliveryMethod,
          checked: selectedList.includes(item.storeDeliveryMethod.uuid),
          title: item.title,
          remarks: item.remarks,
          // enabled: !item.disabled,
        };
      }),
    );
  };
  const rowSelection = {
    selectedRowKeys: (list || [])
      .filter((l) => l.checked)
      .map((l) => l.storeDeliveryMethod.uuid),
    getCheckboxProps: (record) => ({
      disabled: !isPrimary || disableEdit,
    }),
    onChange: onSelectChange,
  };

  const onTableChange = (newList) => {
    onChange(
      newList.map((i) => ({
        checked: i.checked,
        storeDeliveryMethod: i.storeDeliveryMethod,
        title: i.title,
        remarks: i.remarks,
        // enabled: !i.disabled,
      })),
    );
  };

  const TableProps = {
    id: 'salesChannelLogisticsDeliveryMethod',
    rowKey: (record) => record.storeDeliveryMethod.uuid,
    dataSource: list,
    columns: columns,
    rowSelection: rowSelection,
    onTableChange: onTableChange,
    pagination: false,
    hideAllDragHandlers: disableEdit,
  };
  return (
    <div className={styles.logisticMethodTable}>
      {isPrimary ? (
        <EditDraggableTable {...TableProps} />
      ) : (
        <SizeFittingTable {...TableProps} />
      )}
    </div>
  );
};

export default DeliveryMethod;
